(function () {
  'use strict';

  var VARIANT_ID   = 61747764756810;
  var THRESHOLD    = 7500;
  var busy         = false;
  var ourOperation = false; // onderscheidt onze eigen cart-calls van klantenacties
  var timer        = null;

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkAndUpdate, 400);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Met taalprefix (bv. /fr/), anders rendert Shopify de drawer in het Nederlands
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshDrawer() {
    return fetch(ROOT + 'cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var newI = doc.getElementById('CartDrawer-CartItems');
        var curI = document.getElementById('CartDrawer-CartItems');
        if (newI && curI) curI.innerHTML = newI.innerHTML;
        var newF = doc.querySelector('.cart-drawer__footer');
        var curF = document.querySelector('.cart-drawer__footer');
        if (newF && curF) curF.innerHTML = newF.innerHTML;
      });
  }

  function checkAndUpdate() {
    if (busy) return;
    busy = true;

    getCart()
      .then(function (cart) {
        var sampleItem = null;
        var subtotal   = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === VARIANT_ID) sampleItem = item;
        });
        // Bedrag na kortingen (kortingscodes), zoals de klant het betaalt. De sample zelf is €0.
        subtotal = cart.total_price;

        ourOperation = true;

        if (subtotal >= THRESHOLD && !sampleItem) {
          // Toevoegen
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
          }).then(refreshDrawer);

        } else if (subtotal >= THRESHOLD && sampleItem && sampleItem.quantity > 1) {
          // Teveel samples — terugzetten naar 1
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: sampleItem.key, quantity: 1 })
          }).then(refreshDrawer);

        } else if (subtotal < THRESHOLD && sampleItem) {
          // Verwijderen
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: sampleItem.key, quantity: 0 })
          }).then(refreshDrawer);

        } else if (subtotal > 0 && subtotal < THRESHOLD && !(cart.attributes || {})._drempel75_start) {
          // Meting: eerste bedrag waarop de cart onder de drempel zat (onzichtbaar cart-attribuut,
          // komt mee op de order). Order >= €75 met dit attribuut = drempel alsnog gehaald.
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _drempel75_start: (subtotal / 100).toFixed(2) } })
          });

        } else {
          ourOperation = false;
        }
      })
      .catch(function () { ourOperation = false; })
      .then(function () {
        setTimeout(function () {
          ourOperation = false;
          busy = false;
        }, 500);
      });
  }

  // Checkout-guard: valideer de cart op het moment van afrekenen zelf.
  // Zonder deze guard kon je een duur product verwijderen en direct op
  // Afrekenen klikken: de debounced checkAndUpdate was dan nog niet klaar
  // en de gratis sample ging als enige item mee de checkout in.
  var checkoutBusy = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var a = document.createElement('a');
    a.href = form.getAttribute('action') || '';
    if (!/\/cart\/?$/.test(a.pathname)) return; // alleen cart-form, niet /cart/add
    if (e.submitter && e.submitter.name !== 'checkout') return;

    e.preventDefault();
    if (checkoutBusy) return;
    checkoutBusy = true;
    ourOperation = true;

    function toCheckout() { window.location.href = ROOT + 'checkout'; }

    getCart()
      .then(function (cart) {
        var sampleItem = null;
        var subtotal   = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === VARIANT_ID) sampleItem = item;
        });
        // Bedrag na kortingen (kortingscodes), zoals de klant het betaalt. De sample zelf is €0.
        subtotal = cart.total_price;

        if (sampleItem && subtotal < THRESHOLD) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: sampleItem.key, quantity: 0 })
          }).then(function () {
            if (subtotal === 0) {
              // cart bevatte alleen de sample: niet afrekenen, lege cart tonen
              return refreshDrawer().then(function () {
                checkoutBusy = false;
                ourOperation = false;
              });
            }
            toCheckout();
          });
        }
        toCheckout();
      })
      .catch(toCheckout);
  }, true);

  // Intercept window.fetch — pakt alle Dawn cart-calls
  var _fetch = window.fetch;
  window.fetch = function (url, opts) {
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      if (!ourOperation) {
        p.then(function () { scheduleCheck(); });
      }
    }
    return p;
  };

  // Check bij laden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdate);
  } else {
    checkAndUpdate();
  }

}());
